import React from 'react';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { TYPE, URL } from '../../../constant';
import { useUserInfo } from '../../../hooks';

function XbtnTitleHeader({ title, onClose }) {
  const history = useHistory();
  const { info } = useUserInfo();
  
  const onClick = () => {
    if (!info?.learnerId) {
      history.push(URL.ACCOUNT.LOGIN)
    } else if (onClose) {
      onClose();
    }
    else {
      history.goBack();
    }
  }

  return (
    <div className="header">
      <div className="inner">
        <div className="headerBox">
          <div className="headerBox_head">
            <h1 className="tit">{ title }</h1>
            <button
              className={clsx(
                "btn-close-wrap",
                TYPE.CHANNEL.GLOBAL01 === info.channelCode && 'wthie'
              )}
              onClick={onClick}
            >닫기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default XbtnTitleHeader;